if (!customElements.get('dami-stock')) {
  customElements.define(
    'dami-stock',
    class DamiStock extends HTMLElement {
      constructor() {
        super();
        this.stockTxt = this.querySelector('#stockTxt');
        this.stockBar = this.querySelector('#barritaObj');
      }

      connectedCallback() {
        const cantidad = Math.round(Math.random() * (this.stockBar.dataset.valor - 1) + 1);
        const porcentaje = Math.round( (cantidad * 100)/20 );
        this.stockTxt.innerHTML = this.stockTxt.innerHTML.replace("XXX", cantidad);
        this.stockBar.style.width = porcentaje + "%";
      }
    }
  )
}
